const DIRECT_INPUT_VALUE = "D/I";
const DIRECT_INPUT_LABEL = "common:directInput";

export { DIRECT_INPUT_VALUE, DIRECT_INPUT_LABEL };
